import { Link } from "react-router-dom";
import PageHeader from "@/components/feature/PageHeader";
import SectionHeading from "@/components/feature/SectionHeading";

const values = [
  { icon: "ri-compass-3-line", t: "资源聚合", d: "持续收录靠谱的韩国免费漫画网站与APP，把零散的渠道整理成一个清晰的入口。" },
  { icon: "ri-eye-line", t: "实时日更", d: "紧跟热门连载与新作动态，保持日更同步，让读者第一时间看到最新内容。" },
  { icon: "ri-focus-3-line", t: "筛选过滤", d: "从海量站点中筛选稳定、高清、无遮拦的资源，帮读者避开广告满天飞的坑。" },
  { icon: "ri-heart-3-line", t: "真诚分享", d: "用大白话讲清楚韩漫阅读的门道，让新手也能快速上手、少走弯路。" },
];

const principles = [
  "只做资源入口整理，不直接上传漫画内容",
  "持续核验资源站可用性与稳定性",
  "内容表达客观中立，不夸大不吹捧",
  "尊重原创，倡导支持正版阅读",
  "联系方式与品牌信息保持一致、透明",
];

const testimonials = [
  { name: "小橘子", role: "追更三年", text: "以前找韩漫东拼西凑，现在一个页面就能找到全部入口，日更也能一眼看到，省心太多了。" },
  { name: "阿凯", role: "手机党", text: "APP合集整理得很实在，按画质、更新、稳定几个维度挑，我终于选到了顺手的追更工具。" },
  { name: "Momo", role: "刚入坑", text: "题材科普和常见问题对我这种新手特别友好，看完就懂怎么找、怎么看，体验很好。" },
];

const schema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "韩国免费漫画",
  description: "韩国免费漫画资源聚合导航，整理韩国免费漫画网站大全、韩漫APP合集与日更无遮拦在线看入口。",
  inLanguage: "zh-CN",
};

export default function AboutPage() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />

      <PageHeader
        title="关于我们"
        subtitle="ABOUT US"
        desc="我们是一站式「韩国免费漫画」资源聚合导航，致力于把散落在各处的韩国免费漫画网站与APP入口，整理成一个清晰、好用、可持续更新的资源页。"
        crumbs={[{ label: "关于我们" }]}
      />

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-8 md:py-12">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <SectionHeading
              eyebrow="WHO WE ARE"
              title="一个专注于韩漫资源的聚合导航"
              desc="随着韩国漫画的流行，越来越多的读者想找免费、稳定、日更的资源入口，却往往在杂乱的信息里兜圈子。我们想做那个「理清渠道」的角色。"
            />
            <div className="space-y-4 text-sm text-foreground-700 leading-relaxed">
              <p>
                我们持续跟踪韩国免费漫画的网站与APP动态，从更新速度、画质表现、稳定性、无遮拦程度等角度筛选整理，力求每个收录的入口都真实可用。
              </p>
              <p>
                同时，我们也通过文章专题和常见问题，帮助刚接触韩漫的读者快速了解日更机制、无遮拦概念、题材分类等知识，让阅读体验更顺畅。
              </p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {values.map((v) => (
              <div key={v.t} className="rounded-xl bg-background-100 border border-background-200/70 p-5">
                <span className="w-11 h-11 rounded-full bg-primary-100/60 text-primary-500 flex items-center justify-center text-xl">
                  <i className={v.icon}></i>
                </span>
                <h3 className="mt-3 font-heading text-sm text-foreground-950">{v.t}</h3>
                <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100 border-y border-background-200/70">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
          <SectionHeading
            eyebrow="OUR PRINCIPLES"
            title="我们的内容原则"
            desc="资源导航的价值在于「靠谱」与「透明」，这几条原则是我们一直坚持的底线。"
          />
          <ul className="grid md:grid-cols-2 gap-3">
            {principles.map((p) => (
              <li key={p} className="flex items-center gap-3 rounded-lg bg-background-200/60 border border-background-300/50 px-4 py-3 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-fill text-secondary-500"></i>
                {p}
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <SectionHeading
          eyebrow="TESTIMONIALS"
          title="读者怎么说"
          desc="来自不同阅读习惯读者的真实反馈，是我们持续更新的动力。"
          align="center"
        />
        <div className="grid md:grid-cols-3 gap-4">
          {testimonials.map((t) => (
            <div key={t.name} className="rounded-xl bg-background-100 border border-background-200/70 p-5">
              <div className="flex items-center gap-1 text-accent-500">
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
              </div>
              <p className="mt-3 text-sm text-foreground-700 leading-relaxed">“{t.text}”</p>
              <div className="mt-4 flex items-center gap-2.5">
                <span className="w-9 h-9 rounded-full bg-primary-100/60 text-primary-500 flex items-center justify-center text-sm font-heading">
                  {t.name.slice(0, 1)}
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                  <p className="text-[11px] text-foreground-600">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 md:px-6 pb-12 md:pb-16">
        <div className="rounded-2xl border border-background-200/70 bg-gradient-to-br from-background-100 to-background-200/70 p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-950">有合作或建议想聊聊？</h2>
            <p className="mt-2 text-sm text-foreground-600 max-w-lg">无论是资源收录、内容合作还是意见反馈，我们都欢迎你的来信。</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link to="/contact" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-bold text-sm whitespace-nowrap hover:bg-primary-600 transition-colors">
              <i className="ri-chat-3-line"></i> 联系我们
            </Link>
            <Link to="/faq" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300/70 text-foreground-950 font-bold text-sm whitespace-nowrap hover:border-accent-500 hover:text-accent-500 transition-colors">
              <i className="ri-question-line"></i> 查看FAQ
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}